import MobileDetect from 'mobile-detect';

export function bindStickyBar() {
    const md = new MobileDetect(window.navigator.userAgent);
    if (md.mobile() && !md.tablet()) {
        document.querySelector('.sticky-footer-bars').classList.add('sticky');
    }
}
